import type { QcsSyncResourceStore } from 'app-components/flux/core/resourceStoreTypes';
import type { ReportConfigurationProps } from 'app-components/flux/report-configurations/reportConfigurationsTypes';

export const REPORT_CONFIGURATION_DEFAULTS_REDUCER_KEY = 'reportConfigurationDefaultsStore';
export type REPORT_CONFIGURATION_DEFAULTS_REDUCER_KEY = typeof REPORT_CONFIGURATION_DEFAULTS_REDUCER_KEY;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [REPORT_CONFIGURATION_DEFAULTS_REDUCER_KEY]: QcsSyncResourceStore<ReportConfigurationProps>;
  }
}
